/**
 * Contract Config
 *
 * Converts string addresses from BLOCKCHAIN_CONFIG (app.config.ts) into
 * PublicKey objects required by @solana/web3.js and @coral-xyz/anchor.
 *
 * All addresses come from environment variables — see frontend/.env
 */

import { PublicKey } from '@solana/web3.js'
import { BLOCKCHAIN_CONFIG } from './app.config'

const { tokens, platformWallet, contract, solana } = BLOCKCHAIN_CONFIG

const toPubkey = (s: string) => s ? new PublicKey(s) : null

export const CONTRACT_CONFIG = {
  programId:      toPubkey(contract.programId),
  poolPda:        toPubkey(contract.poolPda),
  globalStatePda: toPubkey(contract.globalStatePda),
  poolUsdtAta:    toPubkey(contract.poolUsdtAta),
  poolTakaraAta:  toPubkey(contract.poolTakaraAta),
  operatorPubkey: toPubkey(contract.operatorPubkey),
  usdtMint:       toPubkey(tokens.usdt),
  takaraMint:     toPubkey(tokens.takara),
  platformWallet: toPubkey(platformWallet),
  rpcUrl:         solana.rpcUrl,
  // Direct RPC/WS for on-chain transactions (not backend proxy — avoids WS errors)
  directRpcUrl:   import.meta.env.VITE_SOLANA_RPC_URL || 'https://api.mainnet-beta.solana.com',
  directWsUrl:    import.meta.env.VITE_SOLANA_WS_URL  || 'wss://api.mainnet-beta.solana.com/',
} as const
